import type { ButtonHTMLAttributes } from 'react'

export type ButtonVariant = 'primary' | 'secondary' | 'neutral' | 'danger'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  /** Full width: always (`true`) or only on small screens (`'mobile'`). */
  block?: boolean | 'mobile'
}

export function Button({
  variant = 'primary',
  block = false,
  className,
  type,
  ...rest
}: ButtonProps) {
  const classes = ['ui-button', `ui-button--${variant}`]
  if (block === true) classes.push('ui-button--block')
  if (block === 'mobile') classes.push('ui-button--block-mobile')
  if (className) classes.push(className)
  return <button type={type ?? 'button'} className={classes.join(' ')} {...rest} />
}
